import { render, staticRenderFns } from "./PelletizingProductQualityList.vue?vue&type=template&id=23ad12d2&"
import script from "./PelletizingProductQualityList.vue?vue&type=script&lang=js&"
export * from "./PelletizingProductQualityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports